/**
 * wire-qa entry. The QA harness rides along in the production bundle.
 * This is the fourth thing the release checklist was supposed to catch
 * and the first thing we stopped pretending we would fix. It is
 * harmless: it asserts on constants and prints a table. Mostly it is
 * here so that "but QA needs it in prod" has a receipt.
 */

import { legacyTests } from "./legacy.test";
import { sealConstantTests } from "./seal.test";
import type { TestResult } from "./seal.test";

export const qa = {
  sealConstantTests,
  legacyTests,
  runAll(): TestResult[] {
    return [...sealConstantTests(), ...legacyTests()];
  },
  summary(): { pass: number; fail: number } {
    const all = qa.runAll();
    return { pass: all.filter((r) => r.pass).length, fail: all.filter((r) => !r.pass).length };
  },
};

declare global {
  interface Window {
    __wire?: {
      qa?: typeof qa;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.qa = qa;

  const boot = () => {
    const s = qa.summary();
    // eslint-disable-next-line no-console
    console.info(`[wire-qa] ${s.pass} passed, ${s.fail} failed, all of it constant-shaped`);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
}
